<template>
    <div class="h-full table-container api-keys-container">
        <div class="table-wrapper">
            <table v-if="apiKey_search_arr.length > 0" class="table">
                <thead class="table-head">
                    <tr>
                        <th>Name</th>
                        <th>Token</th>
                        <th>Permissions</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr v-for="apiKey in apiKey_search_arr" :key="apiKey?.id">
                        <td>
                            {{ apiKey?.name }}
                            <a href="#" @click.prevent="$refs['instructions-modal'].showModal()">
                                <i class="icon-question-mark"></i>
                            </a>
                        </td>
                        <td v-if="!currentUserRole.includes('admin')">
                            ***
                        </td>
                        <td v-if="currentUserRole.includes('admin')">
                            <div class="token" >
                                <button class="show-token" @click="apiKey.show = !apiKey.show">
                                    <span v-if="apiKey.show">
                                        {{ apiKey?.key }}
                                    </span>
                                    <i :class="{'icon-view': !apiKey.show,}"></i>
                                </button>
                                <CopyBtn
                                    :value="String(apiKey?.key)"
                                    :isRelative="true"
                                    tooltipPosition="right"
                                />
                            </div>
                            
                        </td>
                        <td class="permissions-col">
                            <!-- <VButton 
                                @clickHandler=" "
                                active
                            >Create</VButton>
                            <VButton 
                                @clickHandler=" "
                                active
                            >Delete</VButton>
                            <VButton 
                                @clickHandler=" "
                                active
                            >Invite</VButton> -->
                        </td>
                        <td>
                            <button
                                v-if="currentUserRole.includes('admin') && currentUserInfo?.id !== apiKey?.id"
                                @click="$refs['confirm-delete-apiKey'].$refs['confirm-delete-apiKey'].showModal(),
                                apiKeyToDeleteID = apiKey?.id"
                                class="delete-member"
                            >
                            <img src="../assets/images/delete-icon.svg" alt="" srcset="">
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <p class="no-apikey-warn" v-if="apiKey_search_arr.length <= 0 && currentUserRole.includes('admin')">No API Key currently. Create one</p>
        <p class="no-apikey-warn" v-if="apiKey_search_arr.length <= 0 && !currentUserRole.includes('admin')">No API Key currently. Only Project Owner can create New Keys</p>
        <VButton
            v-if="currentUserRole.includes('admin')"
            class="new-token-btn"
            @clickHandler="$refs['new-token-modal'].showModal()"
        >+ New Token</VButton>

        <VModal
            title="New Token"
            ref="new-token-modal"
            :flexheight="true"
            size="sm"
            >
            <form @submit.prevent="createAPIKey">
                <VLabeledGroup label="Token name">
                    <Textfield
                        v-model="apiKeyCreateInput"
                        placeholder="MyNewToken"
                    />
                </VLabeledGroup>
        
                <VButton
                    @clickHandler="createAPIKey"
                    active
                >Create</VButton>
            </form>
        </VModal>
        <VModal
            title="How to use"
            ref="instructions-modal"
            :flexheight="true"
            class="instructions-modal"
        >
            <div class="text-holder">
                <p>Creating tasks with an API integration is easy!</p>
                <ol>
                    <li>Select the list the task should be created in</li>
                    <li>Assign your required users</li>
                    <li>Pick a language example</li>
                </ol>
                <p class="text-highlighted">Anyone with the token can create tasks on this board.</p>
            </div>
            <div>
                <label class="select-label">List</label>
                <div class="select-holder">
                    <VSelect 
                        :options="activeBoardTasks"
                        value="id"
                        title="title"
                        @selectHandler="(val) => selectAPIKeyData(val, 'selectedList')"
                    />
                    <i class="icon-arrow-down-small"></i>
                </div>
            </div>
            <div>
                <label class="select-label">Assigned users</label>
                <div class="tags">
                    <div
                        class="wrap-tag"
                        v-for="(user, u) in selectedUsers"
                        :key="u"
                    >
                        <span>{{ activeBoard.members.find(member => member.id == user)?.username }}</span>
                        <span class="delete-tag" @click.prevent="removeTag(u)"></span>
                    </div>
                </div>
                <div class="select-holder">
                    <VSelect 
                        :options="activeBoard.members"
                        value="id"
                        title="username"
                        @selectHandler="(val) => selectAPIKeyData(val, 'selectedUsers', 'multiple')"
                    />
                    <i class="icon-arrow-down-small"></i>
                </div>
            </div>
            <div>
                <label class="select-label">Example</label>
                <div class="lang-btns">
                    <VButton
                        v-for="(lang, l) in exampleLangs"
                        :key="l"
                        @clickHandler="activeExampleLang = lang"
                        :active="activeExampleLang == lang"
                    >{{ lang }}</VButton>
                </div>
                <div class="example-holder">
                    <div class="text-holder">
                        <pre>{{ codeExample[activeExampleLang] }}</pre>
                    </div>
                    <CopyBtn :value="codeExample[activeExampleLang]" />
                </div>
            </div>
        </VModal>
        
        <ConfirmDelete
            ref="confirm-delete-apiKey"
            id="confirm-delete-apiKey"
            title="API Key"
            style="z-index: 300;"
            @delete="deleteAPIKey"
        />
        <Flash ref="show"/>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import VModal from "@/components/atoms/VModal.vue";
import VLabeledGroup from '@/components/molecules/VLabeledGroup.vue'
import ConfirmDelete from "@/components/organism/Confirm.vue";
import Flash from "@/components/Flash.vue";
import CopyBtn from "@/components/atoms/CopyBtn.vue";
import {api} from "@/mixins/axios";
import VSelect from "@/components/atoms/VSelect.vue";

export default {
    name: 'APIKeys',
    props: ['board_id', 'boardOverviewFunc', 'getBoardUpdates'],
    components: {
        VButton,
        Textfield,
        VLabeledGroup,
        VModal,
        Flash,
        ConfirmDelete,
        CopyBtn,
        VSelect
    },
    data() {
        return {
            currentMembers: null,
            apiKey_search_arr: [],
            apiKeyToDeleteID: null,
            apiKeyCreateInput: '',
            currentUserInfo: {},
            showToken: false,
            currentUserRole: '',
            selectedList: null,
            selectedUsers: [],
            exampleLangs: ['cURL', 'Python', 'JavaScript'],
            activeExampleLang: 'JavaScript'
        }
    },
    computed:{
        boards() {
            return this.$store.getters.boards
        },
        currentUser() {
            return this.$store.getters.currentUser
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        activeBoardTasks() {
            return this.$store.getters.activeBoardTasks
        },
        codeExample() {
            return {
                'cURL': `curl --location 'https://0api.goleko.com/api/apikey_new_task' \
--header 'Authorization: Bearer [key]' \
--header 'Content-Type: application/json' \
--data '{
    "list_id": ${this.selectedList},
    "title": "New task",
    "body": "",
    "tags": "|${this.selectedUsers.map(user => 'user:' + user).join('|')}|"
}'`,
                'Python': `import requests
url = 'https://0api.goleko.com/api/apikey_new_task'
headers = {
    'Authorization': 'Bearer [key]',
    'Content-Type': 'application/json'
}
data = {
    'list_id': ${this.selectedList},
    'title': 'New task',
    'body': '',
    'tags': "|${this.selectedUsers.map(user => 'user:' + user).join('|')}|"
}
response = requests.post(url, headers=headers, json=data)
print(response.text)`,
                'JavaScript': `(function() {
	const data = {
		'list_id': ${this.selectedList},
		'title': 'New task',
		'body': '',
		'tags': "|${this.selectedUsers.map(user => 'user:' + user).join('|')}|"
	}
	const response = fetch('https://0api.goleko.com/api/apikey_new_task', {
		method: 'POST',
		headers: {
			'Authorization': 'Bearer [key]',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(data)
	});
    console.log(response.json());
})();`,
            }
        }
    },
    mounted() {
        if (this.boards) {
            this.getMembers()
            this.getCurrentUserUpdates()
            this.getAPIKeys()
            this.tasksSearch()
        }
    },
    watch: {
        boards(value) {
            if (value !== null && this.board_id !== undefined) {
                this.getMembers()
                this.getCurrentUserUpdates()
                this.getAPIKeys()
            }
        },
        board_id(value) {
            if (this.boards !== null && value !== undefined) {
                this.getMembers()
                this.getCurrentUserUpdates()
                this.getAPIKeys()
            }
        }
    },
    methods: {
        getMembers() {
            if(this.board_id && this.boards) {
                const currentBoard = this.boards.filter(board => board.id == this.board_id)
                this.currentMembers = currentBoard[0] && currentBoard[0].members
                this.currentUserRole = currentBoard[0].yourPerms
            }
        },
        getCurrentUserUpdates() {
            this.currentUserInfo = this.currentMembers && this.currentMembers.filter(member => member.id == this.currentUser.id)[0]
        },
        async getAPIKeys() {
            const data = {
                project_id: Number(this.board_id)
            }
            
            try {
                const response = await api.post(`/apikey_search`, data);

                if (response.data?.msg == 'ok') {
                    // add "show" prop. so we can toggle
                    this.apiKey_search_arr = response.data.data.map((apiKey) => {
                        return {
                            ...apiKey,
                            show: false,
                        };
                    });
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg);
            }
        },
        async deleteAPIKey() {
            const data = {
                id: this.apiKeyToDeleteID
            }
            
            try {
                const response = await api.post(`/apikey_delete`, data);

                if (response.data?.msg == 'ok') {
                    this.getAPIKeys()
                    this.$refs.show.showFlashSuccess('API Key deleted successfully');
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg);
            }
        },
        async createAPIKey() {
            const data = {
                project_id: Number(this.board_id),
                name: this.apiKeyCreateInput,
                perms: '|create_task|'
            }
            
            try {
                const response = await api.post(`/apikey_new`, data);

                if (response.data?.msg == 'ok') {
                    this.getAPIKeys()
                    this.$refs.show.showFlashSuccess('API Key created successfully');
                    this.$refs['new-token-modal'].hideModal()
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg);
            }
        },
        selectAPIKeyData(val, prop, savingMode) {
            if(savingMode == 'multiple' && !this[prop].includes(val)) {
                this[prop].push(val)
            } else {
                this[prop] = val
            }
        },
        async tasksSearch() {
            if (!this.activeBoard) {
                this.boardsPreload = true
                this.$store.dispatch('setActiveBoardTasks', [])
                return
            }
            try {
                let data = {
                    project: this.activeBoard['id'],
                    paginate_by: 2000,
                    detailed: true
                };

                data['page'] = this.page
                const response = await api.post(`/task_overview`, data);

                if(response.status === 200) {
                    if(!this.boardsPreload) {
                        this.boardsPreload = true
                    }

                    this.to_time = response.data.to_time
                    
                    const a = this.boards && this.boards.length && this.boards?.filter(board => board?.id == this.board_id)[0]
                    document.title = a && a.title ? `${a.title} | Goleko` : 'Goleko'

                    this.$store.dispatch('setActiveBoardTasks', JSON.parse(JSON.stringify(response.data.data)))

                    this.$store.dispatch('setTemplateTasks', response.data.data.map(list => list.tasks).flat(1).filter(t => t.is_template))
                }
            } catch (e) {
                console.log(e);
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message )
                this.boardsPreload = true
            }
        },
        removeTag(index) {
            this.selectedUsers.splice(index, 1)
        }
    }
}
</script>

<style lang="scss">
.api-keys-container {
    .table {
        th,
        td {
            &:first-child {
                width: auto;
            }
        }
    }
}

.table-container {

    .table-wrapper {
        max-height: 93%;
        overflow-y: auto;

        button {
            border: none;
        }

        .token {
            display: flex;
            align-items: center;
            span {
                margin-right: 10px;
            }
            .hiden-token {
                margin-top: 3px;
            }
            .show-token {
                cursor: pointer;
                color: #fff;
                font-size: 16px;
            }
            .copy-btn {
                padding: 7px 6px 0;
            }
        }
        .icon-question-mark {
            font-size: 11px;
            margin-left: 5px;
        }
    }

    .new-token-btn {
        margin-top: 20px;
        margin-left: 20px;
    }
    .no-apikey-warn {
        margin-bottom: 0;
        padding: 15px 15px 0;
    }

    .permissions-col {
        .btn.light-blue {
            margin-right: 5px;
        }
    }
    .modal-backdrop .modal.light {
        border-radius: 10px;
        padding: 26px;
        width: 340px;

        .modal-header {
            margin-bottom: 0;
            h2 {
                margin-bottom: 10px;
            }
        }

        .modal-body {
            padding: 0;
        }
        .fake-label {
            color: #FFFFFFBF;
            margin-bottom: 12px;
        }
        input.textfield {
            padding: 7px;
        }
    }

    @media screen and (max-width: 789px) {
        overflow-y: auto;
        height: calc(100vh - 220px) !important;
    }
}

.instructions-modal {
    .text-holder {
        background: var(--secondary-bg);
        color: var(--primary-text);
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 10px;
    }

    .text-highlighted {
        color: $orange;
    }

    .select-holder {
        position: relative;
        margin-bottom: 12px;

        & > i {
            font-size: 6px;
            position: absolute;
            right: 19px;
            top: 50%;
            transform: translateY(-50%);
        }

        .custom-select {
            border-radius: 10px;
            border-color: var(--outline);
        }
    }

    .select-label {
        display: block;
        margin-bottom: 5px;
    }

    .tags {
        margin-bottom: 10px;
    }

    .lang-btns {
        margin-bottom: 10px;

        .btn {
            margin-right: 5px;
        }
    }

    .example-holder {
        position: relative;
    }
}
</style>